import { connect } from '@atlassian/jira-react-redux';
import mapDispatchToProps from './command';
import { WithoutParentHeader as View } from './view';

// Remove with the cleanup of com.atlassian.rm.jpo.ease-of-use.remove-no-parent-header
export const WithoutParentHeader = connect(null, mapDispatchToProps)(View);
